export enum TaskPhase {
    Backlog = "backlog",
    Ready = "ready",
    InProgress = "in_progress",
    QA = "qa",
    QABlocked = "qa_blocked",
    Done = "done",
    Production = "production",
    Blocked = "blocked",
}

export enum TaskPriority {
    Critical = "critical",
    High = "high",
    Medium = "medium",
    Low = "low",
}

export enum TaskStatus {
    OnTrack = "on_track",
    AtRisk = "at_risk",
    Delayed = "delayed",
    OnHold = "on_hold",
}
